// extracted by mini-css-extract-plugin
module.exports = {"subtitleWrapper":"DocumentScreen_subtitleWrapper__1-kUk","primaryFieldsWrapper":"DocumentScreen_primaryFieldsWrapper__25zLs","primaryField":"DocumentScreen_primaryField__1P_p7"};